<div class="mb-2 flex items-center justify-between">
  <div class="text-lg font-medium">Protocols</div>

  <button hlmBtn variant="outline" class="flex h-8 gap-2 bg-background">
    <ng-icon hlm size="sm" name="list-filter" />
    Filter
  </button>
</div>

<div hlmCard class="p flex flex-col gap-6 px-7 py-6">
  <div class="relative w-full">
    <ng-icon
      hlm
      name="search"
      size="sm"
      class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2"
    />
    <input
      hlmInput
      type="text"
      placeholder="Search protocols..."
      class="h-8 w-full py-1.5 pl-8"
      (input)="onFilterInput($event)"
    />
  </div>

  <div class="w-full overflow-x-auto">
    <brn-table
      hlm
      [dataSource]="filteredProtocols()"
      [displayedColumns]="_allDisplayedColumns"
      [trackBy]="_trackBy"
    >
      <brn-column-def name="name" class="flex-1">
        <hlm-th truncate *brnHeaderDef>Name</hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          <p hlmBadge size="lg" variant="issue">
            {{ element.name }}
          </p>
        </hlm-td>
      </brn-column-def>

      <brn-column-def name="description" class="flex-1">
        <hlm-th truncate *brnHeaderDef>Description</hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          {{ element.description }}
        </hlm-td>
      </brn-column-def>

      <brn-column-def name="created_at">
        <hlm-th truncate *brnHeaderDef>Created</hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          {{ element.created_at | date: 'dd.MM.yyyy' }}
        </hlm-td>
      </brn-column-def>

      <brn-column-def name="updated_at">
        <hlm-th truncate *brnHeaderDef>Updated</hlm-th>
        <hlm-td truncate *brnCellDef="let element">
          {{ element.updated_at | date: 'dd.MM.yyyy' }}
        </hlm-td>
      </brn-column-def>

      <brn-column-def name="actions" class="w-[140px] justify-end">
        <hlm-th *brnHeaderDef></hlm-th>
        <hlm-td *brnCellDef="let element">
          <div class="flex items-center gap-1.5">
            <button
              hlmBtn
              variant="outline"
              class="bg-background"
              size="sm"
              (click)="viewProtocol(element.id)"
            >
              View
            </button>

            <button hlmBtn variant="ghost" align="end" size="icon" [brnMenuTriggerFor]="menu">
              <ng-icon hlm name="ellipsis-vertical" size="sm" />
            </button>

            <ng-template #menu>
              <hlm-menu>
                <button
                  hlmMenuItem
                  variant="outline"
                  class="flex cursor-pointer gap-2 text-destructive hover:bg-destructive/10 hover:text-destructive"
                  size="sm"
                  (click)="handleDelete(element.id)"
                >
                  <ng-icon hlm name="trash" size="sm" />
                  Delete
                </button>
              </hlm-menu>
            </ng-template>
          </div>
        </hlm-td>
      </brn-column-def>

      <div class="flex items-center justify-center p-20 text-muted-foreground" brnNoDataRow>
        No protocols found
      </div>
    </brn-table>
  </div>
</div>
